const developmentBackendOrigin =
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}/website/public`
    : "http://localhost/website/public";

const productionBackendBase =
  typeof window !== "undefined"
    ? (window.__SANGGAVAI_BASE_PATH__ || "").replace(/\/+$/, "")
    : "";

const configuredBackendOrigin = (
  process.env.REACT_APP_BACKEND_ORIGIN ||
  (process.env.NODE_ENV === "development"
    ? developmentBackendOrigin
    : productionBackendBase)
).replace(/\/+$/, "");

export function backendUrl(path = "") {
  if (!path || /^(?:https?:|data:)/i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${configuredBackendOrigin}${normalizedPath}`;
}